export { default } from "./modal-content";
